import React from "react";
import Slider from "react-slick";
// import img1 from "../assets/img1.jpg";
import img2 from "../assets/img2.jpg";
import img3 from "../assets/img3.jpg";
import img4 from "../assets/img5.jpg";
import Logo from "../assets/PNG.png";

const sliderImages = [ img2, img3, img4];

const SlickSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  return (
    <div className="relative w-full h-full overflow-hidden">
      {/* Slider */}
      <Slider {...settings} className="w-full h-full">
        {sliderImages.map((image, index) => (
          <div key={index} className="w-full h-full">
            <img
              src={image}
              alt={`Slide ${index}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </Slider>
      <div className="absolute inset-0 flex flex-col   text-black md:text-center p-4">
        <img
          className="md:w-[210px] md:h-[210px] w-[160px]  h-[160px] md:ml-[44%] ml-[40%]  "
          src={Logo}
          alt="Logo"
        />
        <h2 className="md:text-4xl text-3xl  font-bold mb-4 md:absolute md:top-[150px] md:left-[600px] absolute top-[120px] left-[150px]"><span className="text-pink-600">Future</span>  Skill</h2>
        <p className="md:text-lg  text-white">
          Enhance your skills for a brighter future with our comprehensive
          programs and courses designed to help you excel.
        </p>
      </div>
    </div>
  );
};

export default SlickSlider;
